const initCategories = () => {
  jQuery('.js-categories-marker').mouseenter(function () {
      jQuery(this).parent().addClass('is-active')
      jQuery(this).parent().parent().addClass('is-active')
  })

  jQuery('.js-categories-marker').mouseleave(function () {
      jQuery(this).parent().removeClass('is-active')
      jQuery(this).parent().parent().removeClass('is-active')
  })
}

export {initCategories}